import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  IconButton,
  InputBase,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Button,
  Paper,
  Popover,
  Dialog,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '../../../../assets/Admin/RequestImages/filter-icon.svg';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import './AddInstructorModal.css';
import { axiosInstance } from '../../../../utils/tokenUtils';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import OneOnOneSessionIcon from '../../../../assets/Admin/SessionIcons/one-on-one-session-icon.svg';
import GroupSessionIcon from '../../../../assets/Admin/SessionIcons/group-session-icon.svg';
import PrimeSessionIcon from '../../../../assets/Admin/SessionIcons/prime-session-icon.svg';
import ReactCountryFlag from 'react-country-flag';
import { getCode as getCountryCodeByName } from 'country-list';

const AddInstructorModal = ({ onClose, onSuccess, organizationId }) => {
  return <Box className="add-instructor-page-container"></Box>;
};

export default AddInstructorModal;
